<template>
    <nav>
        <section class="absolute right-0 cursor-pointer transition-back" style="top: 0; position: fixed!important; height: 74px; margin: 15px; z-index: 1000" :class="{'bg-coding': !showMenu, 'shadow': !showMenu, 'bg-transparant': showMenu}" @click="toggleMenu()">
            <div class="w-auto relative" style=" width: 70px!important; margin-top: 19px" @keydown.esc="toggleMenu()">
                <div class="hamburger hamburger--spring" :class="{'is-active': showMenu }">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </div>
            </div>
            <p v-if="!showMenu" class="font-serif text-center pt-6">MENU</p>
        </section>
        <section class="fixed w-full h-screen bg-agency gradient top-0 left-0 flex items-center justify-center align-center z-50 slider" :class="{'closed': !showMenu }">
            <div class="lg:flex w-full content-center h-screen align-center align-end border-bottom">
                <a href="/" class="tracking-tight font-serif font-bold text-white text-3xl lg:text-4xl xl:text-5xl w-1/5 menu-item text-center hover:bg-coding lg:h-screen text-center align-center  lg:h-full hover:bg-coding menu-item-length py table">
                    <span class="table-cell">
                            <span class="hidden lg:block">
                                <img src="/svg/beeldmerk-white_animated.svg" class="menu-logo w-1/6 mx-auto" alt="">
                                <small class="block x-normal pt-6">
                                    <span class="text-coding tracking-wide">/</span>Home
                    </small>
                    </span>
                    <span class="block lg:hidden">
                                <img src="/svg/beeldmerk-white_animated.svg" class="w-1/5 mx-auto menu-logo" alt="">
                            </span>
                    </span>
                </a>
                <a href="/about" class="tracking-tight font-serif font-bold text-white text-3xl lg:text-4xl xl:text-5xl w-1/5 menu-item text-center hover:bg-coding lg:h-screen text-center align-center  lg:h-full  hover:bg-coding menu-item-length py table ">
                    <span class="table-cell">
                            <span class="text-coding tracking-wide">/</span>About
                    <small class="block font-normal  animated delay-1s slower fadeIn">Over Coding Agency</small>
                    </span>
                </a>
                <a href="/expertises" class="tracking-tight font-serif font-bold text-white text-3xl lg:text-4xl xl:text-5xl w-1/5 menu-item text-center hover:bg-coding lg:h-screen text-center align-center  lg:h-full  hover:bg-coding menu-item-length py table">
                    <span class="table-cell">
                            <span class="text-coding tracking-wide">/</span>Expertises
                    <small class="block font-normal  animated delay-1s slower fadeIn">Welke diensten bieden wij?</small>
                    </span>
                </a>
                <a href="/cases" class="tracking-tight font-serif font-bold text-white text-3xl lg:text-4xl xl:text-5xl w-1/5 menu-item text-center hover:bg-coding lg:h-screen text-center align-center  lg:h-full  hover:bg-coding menu-item-length py table">
                    <span class="table-cell">
                            <span class="text-coding tracking-wide">/</span>Cases
                    <small class="block font-normal  animated delay-1s slower fadeIn">Overzicht recent werk</small>
                    </span>
                </a>
                <a href="/contact" class="tracking-tight font-serif font-bold text-white text-3xl lg:text-4xl xl:text-5xl w-1/5 menu-item text-center hover:bg-coding lg:h-screen text-center align-center  lg:h-full  hover:bg-coding menu-item-length py table">
                    <span class="table-cell">
                            <span class="text-coding tracking-wide">/</span>Contact
                    <small class="block font-normal  animated delay-1s slower fadeIn">Op de koffie?</small>
                    </span>
                </a>
            </div>
        </section>
    </nav>
</template>
<script>
// https://maxwellito.github.io/vivus-instant/
export default {
    mounted() {
        console.log('Hamburger mounted.');
    },
    created() {
        let that = this;
        document.addEventListener('keyup', function(evt) {
            if (evt.keyCode === 27) {
                that.toggleMenu();
            }
        });
    },
    data() {
        return {
            showMenu: false,
        }
    },
    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu;
            const body = document.querySelector('body');
            if (this.showMenu) {
                window.scrollTo(0, 0);
                body.style.position = 'fixed';
                body.style.position = 'hidden';
            } else {
                body.removeAttribute('style');
            }
        }
    }
}
</script>
<style scoped>
.bg-transparant {
    background: none;
}

.table {
    display: table;
}

.table-cell {
    display: table-cell;
    vertical-align: middle;
}

.menu-item {
    transition-property: all;
    transition-duration: 2.4s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.menu-item:hover {
    color: #3f3e29!important;
}

.menu-item:hover .text-coding {
    color: white!important;
}

.menu-round {
    background: pink;
    border-radius: 100%;
    display: ;
}

.border-bottom {
    border-bottom: 24px solid #fdb825;
}

.py {
    padding: 0.7rem 20px
}

.font-normal {
    font-weight: normal!important
}

.slider {
    overflow-y: hidden;
    height: 100vh;
    max-height: 100vh;
    transition-property: all;
    transition-duration: .5s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

@media screen and (max-width: 360px) {
    .menu-logo  {
        display: none!important;
    }
}
@media screen and (max-width: 1023px) {
    .menu-item-length {
        width: 100%!important;
    }
}

.slider.closed {
    max-height: 0;
}

. {
    transition: background .5s;
    transition: background-image 1s;
}

a.transition-back:hover {
    background-image: linear-gradient(145deg, rgba(253, 184, 37, 0.1), rgba(253, 184, 37, 1));
}

.hamburger {
    padding: 0 15px;
    display: inline-;
    cursor: pointer;
    transition-property: opacity, filter, background;
    transition-duration: 0.15s;
    transition-timing-function: linear;
    font: inherit;
    color: inherit;
    text-transform: none;
    background-color: transparent;
    border: 0;
    margin: 0;
    overflow: visible;
}

.bg-agency.gradient {
    background-image: linear-gradient(145deg, rgba(63, 62, 41, 1), rgba(63, 62, 41, 0.8))!important
}

.hamburger:hover {
    opacity: 0.7;
}

.hamburger.is-active:hover {
    opacity: 0.7;
}

.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner::before,
.hamburger.is-active .hamburger-inner::after {
    background-color: #3f3e29;
}


/*.bg-agency .hamburger.is-active .hamburger-inner,*/

.bg-transparant .hamburger.is-active .hamburger-inner::before,
.bg-transparant .hamburger.is-active .hamburger-inner::after {
    background-color: #fdb825!important;
}

.hamburger-box {
    width: 40px;
    height: 54px;
    height: auto;
    display: inline-;
    position: relative;
}

.hamburger-inner {
    display: ;
    top: 50%;
    margin-top: -2px;
}

.hamburger-inner,
.hamburger-inner::before,
.hamburger-inner::after {
    width: 40px;
    height: 4px;
    background-color: #3f3e29;
    border-radius: 4px;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
}

.bg-agency .hamburger-inner,
.bg-agency .hamburger-inner::before,
.bg-agency .hamburger-inner::after {
    background-color: #fdb825!important;
}

.hamburger-inner::before,
.hamburger-inner::after {
    content: "";
    display: ;
}

.hamburger-inner::before {
    top: -10px;
}

.hamburger-inner::after {
    bottom: -10px;
}


/*
   * Spring
   */

.hamburger--spring .hamburger-inner {
    top: 0px;
    transition: background-color 0s 0.13s linear;
}

.hamburger--spring .hamburger-inner::before {
    top: 10px;
    transition: top 0.1s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.hamburger--spring .hamburger-inner::after {
    top: 20px;
    transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.hamburger--spring.is-active .hamburger-inner {
    transition-delay: 0.22s;
    background-color: transparent !important;
}

.hamburger--spring.is-active .hamburger-inner::before {
    top: 0;
    transition: top 0.1s 0.15s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s 0.22s cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 10px, 0) rotate(45deg);
}

.hamburger--spring.is-active .hamburger-inner::after {
    top: 0;
    transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s 0.22s cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 10px, 0) rotate(-45deg);
}


/*
   * Spring Reverse
   */

.hamburger--spring-r .hamburger-inner {
    top: auto;
    bottom: 0;
    transition-duration: 0.13s;
    transition-delay: 0s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.hamburger--spring-r .hamburger-inner::after {
    top: -20px;
    transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), opacity 0s linear;
}

.hamburger--spring-r .hamburger-inner::before {
    transition: top 0.1s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.hamburger--spring-r.is-active .hamburger-inner {
    transform: translate3d(0, -10px, 0) rotate(-45deg);
    transition-delay: 0.22s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}

.hamburger--spring-r.is-active .hamburger-inner::after {
    top: 0;
    opacity: 0;
    transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0s 0.22s linear;
}

.hamburger--spring-r.is-active .hamburger-inner::before {
    top: 0;
    transform: rotate(90deg);
    transition: top 0.1s 0.15s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s 0.22s cubic-bezier(0.215, 0.61, 0.355, 1);
}
</style>
